var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","align-right":""}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Remove"},on:{"click":function($event){return _vm.removeFromCart(_vm.product)}}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("x")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }